<template>
  <div class="rank-container">
    <img class="apply-rank-img"
         v-if="index===0"
         src="~assets/pics/rank1.png"
         alt="rank" />
    <img class="apply-rank-img"
         v-else-if="index===1"
         src="~assets/pics/rank2.png"
         alt="rank" />
    <img class="apply-rank-img"
         v-else-if="index===2"
         src="~assets/pics/rank3.png"
         alt="rank" />
    <img v-else
         class="apply-rank-img"
         src="~assets/pics/ranks.png"
         alt="rank" />
    <div class="apply-rank-number"
         v-if="index > 2">
      {{index + 1}}
    </div>
    <div class="apply-rank-softname"
         @click="showSoftDetail(detail.softName)"
         :style="getFontStyle(index)">
      {{detail.softName}}
    </div>
    <el-tag class="apply-rank-count"
            :style="getTagStyle(index)"
            type="success"
            effect="plain">{{languages.like + ' ' +
            detail.voteNum + ' ' + languages.time}}</el-tag>
    <img class="apply-rank-vote"
         v-if="detail.isVoted==='0'"
         @click="toVote(detail)"
         src="~assets/pics/nice.png"
         alt="rank" />
    <img class="apply-rank-voted"
         v-if="detail.isVoted==='1'"
         src="~assets/pics/niced.png"
         alt="rank" />
  </div>
</template>

<script>

export default {
  inject: ['applicationTemplate'],
  props: {
    languages: Object,
    detail: Object,
    index: Number,
    count: Number,
    status: Number,

  },
  methods: {
    getFontStyle (index) {
      switch (index) {
        case 0:
          return 'color:#ff833c';
        case 1:
          return 'color:#ffbf29';
        default:
          return '';
      }
    },
    showSoftDetail (name) {
      this.$message.success(name);
    },
    getTagStyle (index) {
      switch (index) {
        case 0:
          return 'color:#ff833c;border-color:#ff833c';
        case 1:
          return 'color:#ffbf29;border-color:#ffbf29';
        default:
          return '';
      }
    },
    toVote (item) {
      this.applicationTemplate.voteRank(item);
    },
  },
};
</script>

<style lang="scss" scoped>
.rank-container {
  width: 440px;
  position: relative;
  .apply-rank-img {
    width: 440px;
    position: relative;
  }
  .apply-rank-number {
    width: 60px;
    position: absolute;
    left: 0px;
    top: 12px;
    font-weight: 700;
    color: #fff;
  }
  .apply-rank-softname {
    text-align: left;
    position: absolute;
    cursor: pointer;
    left: 80px;
    top: 25px;
    font-weight: 700;
    font-size: 16px;
    color: #0080ff;
    width: 230px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .apply-rank-count {
    position: absolute;
    right: 50px;
    top: 24px;
    width: 85px;
    height: 26px;
    line-height: 26px;
    border-radius: 13px;
  }
  .apply-rank-vote,
  .apply-rank-voted {
    position: absolute;
    right: 15px;
    top: 22px;
    width: 28px;
    height: 28px;
    cursor: pointer;
  }
  .apply-rank-voted {
    cursor: default;
  }
}
</style>
